/* eslint-disable react/jsx-props-no-spreading */

import React from 'react'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'
// Local
import { shouldRenderReskin2025 } from '../../../constant'
import { RootState } from '../../../store'

const black = '#000000'

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps

function PrinterIcon(
  props: Props
): JSX.Element {
  const {
    ...rest
  } = props

  if (!shouldRenderReskin2025) {
    return (
      <Icon
        /**
         * Have to prop spread because popover wraps this in many
         * cases and the tooltip / popover will not work without this (prop forwarding).
        */
        { ...rest }
        name="print"
        size="large"
        color="grey"
        className="pointer"
      />
    )
  }
  return (
    <svg
      /**
         * Have to prop spread because popover wraps this in many
         * cases and the tooltip / popover will not work without this (prop forwarding).
        */
      { ...rest }
      className="icon reveleer-printer"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M3.99999 0H16V4H3.99999V0ZM3 4.99995H17C18.66 4.99995 20 6.33995 20 7.99995V14H16V18H4V14H0V7.99995C0 6.33995 1.34 4.99995 3 4.99995ZM5.99998 16H14V11H5.99998V16ZM17 9.00001C16.45 9.00001 16 8.55001 16 8.00001C16 7.45001 16.45 7.00001 17 7.00001C17.55 7.00001 18 7.45001 18 8.00001C18 8.55001 17.55 9.00001 17 9.00001Z"
        fill={ black }
      />
    </svg>
  )
}


export default connect(mapStateToProps)(PrinterIcon)
